module.exports = __webpack_public_path__ + "static/media/mmm-lockup.44c42da0.svg";